"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createEmotionCache: true
};
Object.defineProperty(exports, "createEmotionCache", {
  enumerable: true,
  get: function () {
    return _createCache.default;
  }
});
var _pagesRouterV13Document = require("./pagesRouterV13Document");
Object.keys(_pagesRouterV13Document).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _pagesRouterV13Document[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pagesRouterV13Document[key];
    }
  });
});
var _pagesRouterV13App = require("./pagesRouterV13App");
Object.keys(_pagesRouterV13App).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _pagesRouterV13App[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pagesRouterV13App[key];
    }
  });
});
var _createCache = _interopRequireDefault(require("./createCache"));